import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Ripple } from 'primereact/ripple';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import { Dialog } from "primereact/dialog";
import 'swiper/css';
import 'swiper/css/navigation';

import { Fade, JackInTheBox, Slide } from "react-awesome-reveal";

import './Plans.css';
import './Plans-responsive.css';
import './Pricing.css'
import './Pricing-responsive.css';
import { fetchPlans, fetchUserTypes } from "../../Controllers/Thunks/plansThunks";
import { useAppDispatch, useAppSelector } from "../../Controllers/hooks";
import { selectMappedUserType } from "../../Controllers/selector";
import { Subscription } from "../../Controllers/Types/SubscriptionInterface";
import { UserType } from "../../Controllers/Types/UserTypeInterface";
import { decrementNumberOfProjects, filterPlansBySelectedUserTpe, incrementNumberOfProjects } from "../../Controllers/Slices/subscriptionSlice";
import Preloader from "../../Components/Preloader";
import { goToTop } from "../../Components/goToTop";
import NeedHelp from "../../../Website/Pages/CommonSections/NeedHelp";
import ErrorPage from "../../Components/ErrorPage";
import { getAppCurrencyType } from "../../Utils/Common";
import { playStoreLink, appStoreLink } from "../../../Website/Utils/Info";
import { setSelectUserType } from "../../Controllers/Slices/userTypeSlice";
import { ProgressSpinner } from "primereact/progressspinner";


const Plans = () => {
    const dispatch = useAppDispatch();
    const currencySymbol = getAppCurrencyType();

    //const mappedUserTypes = useAppSelector(selectMappedUserType)
    const mappedUserTypes = useAppSelector((state) => state.userTypes.userTypes)
    const selectedUserType = useAppSelector((state) => state.userTypes.selectedUserType)
    const userTypeSubscriptions = useAppSelector((state) => state.subscriptions.userTypeSubscriptions)
    const loadingUserType = useAppSelector((state) => state.userTypes.loading)
    const loadingPlan = useAppSelector((state) => state.subscriptions.loading)
    const error = useAppSelector((state) => state.userTypes.error || state.subscriptions.error)
    const [showSubscriptionAlert, setShowSubscriptionAlert] = useState<boolean>(false);

    const [planViewStep, setPlanViewStep] = useState<number>(1);


    const handleClickUserType = (userType: UserType | null) => {
        if (!userType) return;

        const isAlreadySelected = selectedUserType?.id === userType.id;

        if (isAlreadySelected) {
            dispatch(setSelectUserType(null));
            dispatch(filterPlansBySelectedUserTpe(null)); // reset filter
        } else {
            dispatch(setSelectUserType(userType));
            dispatch(filterPlansBySelectedUserTpe(userType.id));
        }
    };

    const handleIncrement = (planId: number) => {
        dispatch(incrementNumberOfProjects(planId));
    };

    const handleDecrement = (planId: number) => {
        dispatch(decrementNumberOfProjects(planId));
    };

    const breakpoints = {
        320: {
            slidesPerView: 1.5,
            spaceBetween: 10,
        },
        576: {
            slidesPerView: 2.5,
        },
        768: {
            slidesPerView: 2.5,
        },
        991: {
            slidesPerView: 3.5,
        },
        1200: {
            slidesPerView: 4,
        },
        1400: {
            slidesPerView: 5,
        },
        1920: {
            slidesPerView: 5,
        },
    };

    useEffect(() => {
        dispatch(fetchUserTypes());
        dispatch(fetchPlans());
    }, [dispatch]);

    // useEffect(() => {
    //     if (mappedUserTypes.length > 0 && !selectedUserType) {
    //         setSelectedUserType(mappedUserTypes[0]);
    //     }
    // }, [mappedUserTypes, selectedUserType]);

    // useEffect(() => {
    //     if (selectedUserType) {
    //         setSelectedUserType(mappedUserTypes.find(userType => userType.id === selectedUserType.id) || null);
    //     }
    // }, [mappedUserTypes, selectedUserType]);

    // if (statusUserType || statusPlan) {
    //     return <div><Preloader /></div>;
    // }

    if (error) {
        return (<ErrorPage errorMessage={error} />);
    }

    const handleShowSubscriptionAlert = () => {
        setShowSubscriptionAlert(true);
        setTimeout(() => {
            setShowSubscriptionAlert(false);
        }, 10000);
        goToTop();
    }

    return (
        <React.Fragment>
            {/* Plans section */}
            {loadingUserType || loadingPlan ? (
                <div className="loading_container">
                    <ProgressSpinner
                        className="progresscircle custom"
                        style={{ width: "50px", height: "50px", stroke: "#8953D7" }}
                        strokeWidth="8"
                        fill="var(--surface-ground)"
                        animationDuration="1s"
                    />
                </div>
            ) : (
                <section className="page_initial_section pricing_init_section pattern_bg overflow-hidden">
                    <div className="container-md">
                        <div className="page_heading_area">
                            <Slide direction="up" triggerOnce>
                                <h2 className="page_heading text-center">
                                    Our Pricing Plan
                                </h2>
                            </Slide>
                            <Slide direction="up" delay={100} triggerOnce>
                                <p className="page_desc text-center">
                                    Explore our flexible pricing plans designed to fit your needs and budget, ensuring you get the most value for your project.
                                </p>
                            </Slide>
                        </div>

                        {planViewStep === 1 ? (
                            <Slide direction="up" triggerOnce>
                                <div className="plan_selection_area">
                                    <h3>Select your role below:</h3>

                                    <div className="user_type_options_area">
                                        {mappedUserTypes?.map((userTypeOption) => {
                                            const isSelected = selectedUserType?.id === userTypeOption?.id;
                                            return (
                                                <button className={`user_type_option_btn p-ripple ${isSelected ? 'selected' : ''}`}
                                                    onClick={() => handleClickUserType(userTypeOption)}>
                                                    <img src={userTypeOption?.logo} loading="lazy" alt="" />
                                                    <span className="user_type_option_label">{userTypeOption?.typeName}</span>
                                                    <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                                </button>
                                            )
                                        })}
                                    </div>

                                    <div className="selection_btn_area">
                                        <button
                                            className="next_btn p-ripple"
                                            onClick={() => setPlanViewStep(2)}
                                            disabled={!selectedUserType}
                                        >
                                            Next
                                            <div className="icon_circle">
                                                <i className="bi bi-arrow-right"></i>
                                            </div>
                                            <Ripple />
                                        </button>
                                    </div>
                                </div>
                            </Slide>
                        ) : (
                            <>
                                <Slide direction="up" triggerOnce>
                                    <h6 className="pricing_selection_title">Select your role here</h6>
                                </Slide>

                                {/* {selectedUserType && ( */}
                                {mappedUserTypes && mappedUserTypes?.length > 0 && (
                                    <ul className="plan_choose_slider_section" id="plans-tab" role="tablist">
                                        <Slide direction="up" triggerOnce>
                                            <Swiper
                                                className='hero-swiper-area'
                                                modules={[Navigation]}
                                                spaceBetween={15}
                                                slidesPerView={5}
                                                loop={false}
                                                breakpoints={breakpoints}
                                                navigation={{
                                                    nextEl: '.next_tab_btn',
                                                    prevEl: '.prev_tab_btn',
                                                }}
                                                grabCursor={true}
                                            >
                                                {mappedUserTypes.map((userType, index) => (
                                                    <SwiperSlide className="user_role_slide">
                                                        {userType.id === selectedUserType?.id ? (
                                                            <li className="nav-item" role="presentation" key={selectedUserType?.id} >
                                                                <button className={`plan_choose_tab p-ripple active`} id="plan_tab1"
                                                                    data-bs-toggle="pill" data-bs-target="#plan_tab_content1"
                                                                    type="button" role="tab" aria-controls="plan_tab_content1" aria-selected="true" onClick={() => handleClickUserType(userType)}>
                                                                    <img src={userType?.logo} className="icon_img" loading="lazy" alt="" />
                                                                    <span>{userType?.typeName}</span>
                                                                    <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                                                </button>
                                                            </li>
                                                        ) : (
                                                            <li className="nav-item" role="presentation" key={selectedUserType?.id} >
                                                                <button className="plan_choose_tab p-ripple" id="plan_tab1"
                                                                    data-bs-toggle="pill" data-bs-target="#plan_tab_content1"
                                                                    type="button" role="tab" aria-controls="plan_tab_content1" aria-selected="true" onClick={() => handleClickUserType(userType)}>
                                                                    <img src={userType?.logo} className="icon_img" loading="lazy" alt="" />
                                                                    <span>{userType?.typeName}</span>
                                                                    <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                                                </button>
                                                            </li>
                                                        )}
                                                    </SwiperSlide>
                                                ))}
                                            </Swiper>
                                        </Slide>

                                        <button className="tab_slide_btn prev_tab_btn p-ripple">
                                            <i className="ri-arrow-left-s-line"></i>
                                            <Ripple />
                                        </button>
                                        <button className="tab_slide_btn next_tab_btn p-ripple">
                                            <i className="ri-arrow-right-s-line"></i>
                                            <Ripple />
                                        </button>
                                    </ul>
                                )}
                                {/* )} */}

                                {selectedUserType && selectedUserType !== null ? (
                                    <div className="tab-content plans_details_section mx-auto" id="plans-tabContent">
                                        <div className="tab-pane fade show active" id="plan_tab_content1" role="tabpanel" aria-labelledby="plan_tab1" tabIndex={0}>
                                            {userTypeSubscriptions!.length > 0 ? (
                                                <div className="row justify-content-center plans_detail_row">
                                                    {userTypeSubscriptions.map((plan, index) => (
                                                        <div className="col-12 col-xxl-3 col-xl-3 col-md-6 col-sm-6 col-lg-4" key={plan.id}>
                                                            <Slide direction="up" delay={index * 50} triggerOnce>
                                                                <article className="plan_card">
                                                                    <h2 className="plan_card_title text-center">{plan.plan_name}</h2>
                                                                    <h1 className="plan_card_price text-center">
                                                                        {currencySymbol}&nbsp;<span className="price">{plan.monthly * plan.numberOfProjects}</span>
                                                                        <span className="validity">/ m</span>
                                                                    </h1>

                                                                    {plan.monthly > 0 ? (
                                                                        <div className="plan_card_action_area text-center">
                                                                            <div className="plan_card_quantity_area">
                                                                                <button
                                                                                    className="plan_card_quantity_btn decrement p-ripple"
                                                                                    onClick={() => handleDecrement(plan.id)}
                                                                                    disabled={plan.numberOfProjects <= 1}>
                                                                                    <i className="bi bi-caret-left-fill"></i>
                                                                                    <Ripple />
                                                                                </button>

                                                                                <input
                                                                                    type="number"
                                                                                    className="plan_card_quantity_input"
                                                                                    readOnly
                                                                                    value={plan.numberOfProjects}
                                                                                />

                                                                                <button
                                                                                    className="plan_card_quantity_btn increment p-ripple"
                                                                                    onClick={() => handleIncrement(plan.id)}
                                                                                    disabled={plan.numberOfProjects === plan.max_license_counts}>
                                                                                    <i className="bi bi-caret-right-fill"></i>
                                                                                    <Ripple />
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    ) : (
                                                                        <div className="plan_card_action_area text-center">
                                                                            <h4 className="plan_card_desc">One month only</h4>
                                                                        </div>
                                                                    )}

                                                                    <div className="plan_card_btn_area">
                                                                        {plan.monthly > 0 ? (
                                                                            // <button
                                                                            //     className="plan_card_btn p-ripple"
                                                                            //     onClick={handleShowSubscriptionAlert}>
                                                                            //     Subscribe now
                                                                            //     <Ripple />
                                                                            // </button>
                                                                            <Link
                                                                                to={'/auth/signup'}
                                                                                state={{ userTypeId: selectedUserType!.id, planId: plan.id, numberOfProjects: plan.numberOfProjects, monthlyAmount: plan.fixed_amount, planName: plan.plan_name, maxLicenseCounts: plan.max_license_counts }}
                                                                                className="plan_card_btn p-ripple"
                                                                                onClick={goToTop}>
                                                                                Subscribe now
                                                                                <Ripple />
                                                                            </Link>
                                                                        ) : (
                                                                            <Link
                                                                                to={'/auth/signup'}
                                                                                state={{ userTypeId: selectedUserType!.id, planId: plan.id, numberOfProjects: plan.numberOfProjects, monthlyAmount: plan.fixed_amount, planName: plan.plan_name, maxLicenseCounts: plan.max_license_counts }}
                                                                                className="plan_card_btn p-ripple"
                                                                                onClick={goToTop}>
                                                                                Start free trial
                                                                                <Ripple />
                                                                            </Link>
                                                                        )}
                                                                    </div>

                                                                    <div className="plan_card_feature_area">
                                                                        <ul className="plan_card_feature_list">
                                                                            {plan.feature.slice(0, 3).map(fea => (
                                                                                <li key={fea.feature_name}><span>{fea.feature_name}</span></li>
                                                                            ))}
                                                                        </ul>
                                                                    </div>

                                                                    <button className="plan_card_feature_btn p-ripple d-block mx-auto mb-1"
                                                                        data-bs-toggle="modal" data-bs-target="#featureModal">
                                                                        See all feature
                                                                        <Ripple />
                                                                    </button>
                                                                </article>
                                                            </Slide>
                                                        </div>
                                                    ))}
                                                </div>
                                            ) : (
                                                <div className="row justify-content-center plans_detail_row">
                                                    <div className="col-12 mx-auto">
                                                        <Fade triggerOnce>
                                                            <div className="no_data_found_container">
                                                                <JackInTheBox triggerOnce>
                                                                    <img src="/assets/images/no_data/no_packages.svg" loading="lazy" alt="No questions found!" />
                                                                </JackInTheBox>
                                                                <Fade triggerOnce>
                                                                    <h6>Oops! There are currently no plans for this role.</h6>
                                                                </Fade>
                                                            </div>
                                                        </Fade>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                ) : (
                                    <div className="tab-content plans_details_section mx-auto" id="plans-tabContent">
                                        <div className="tab-pane fade show active" id="plan_tab_content1" role="tabpanel" aria-labelledby="plan_tab1" tabIndex={0}>
                                            <div className="row justify-content-center plans_detail_row">
                                                <div className="col-12 mx-auto">
                                                    <Fade triggerOnce>
                                                        <div className="no_data_found_container">
                                                            <JackInTheBox triggerOnce>
                                                                <img src="/assets/images/website/common/user_role.svg" loading="lazy" alt="No questions found!" />
                                                            </JackInTheBox>
                                                            <Fade triggerOnce>
                                                                <h6>Please select your role above.</h6>
                                                            </Fade>
                                                        </div>
                                                    </Fade>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </>
                        )}

                    </div>
                </section>
            )}

            {/* Need help section */}
            <NeedHelp />

            {/* Plan feature modal here */}
            <div className="modal fade" id="featureModal" tabIndex={-1} aria-labelledby="featureModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-xl feature_modal_area">
                    <div className="modal-content feature_modal">
                        <div className="modal_head">
                            <h2 className="modal_head_title" id="featureModalLabel">
                                {selectedUserType?.typeName}
                            </h2>
                        </div>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        <div className="modal-body">
                            <div className="row plan_feature_row justify-content-center">
                                {userTypeSubscriptions.map(plan => (
                                    <div className="col-12 col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-6">
                                        <article className="plan_feature_card h-100">
                                            <h4 className="plan_feature_head text-center">{plan.plan_name}</h4>

                                            <div className="plan_features_area">
                                                <ul className="plan_card_feature_list">
                                                    {plan.feature.map(fea => (
                                                        <li><span>{fea.feature_name}</span></li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </article>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/*  */}

            {/* Subscription alert */}
            <Dialog headerClassName="d-none" dismissableMask
                visible={showSubscriptionAlert} className="custom_modal_dialog modal_dialog_md"
                onHide={() => { if (!showSubscriptionAlert) return; setShowSubscriptionAlert(false); }}>
                <div className="custom_modal_body">
                    <button className="custom_modal_close position-absolute float p-ripple"
                        onClick={() => setShowSubscriptionAlert(false)}>
                        <i className="bi bi-x-lg"></i>
                        <Ripple />
                    </button>

                    <div className="use_case_feature_info">
                        <h6 className="review_head">Subscription Alert!</h6>

                        <div className="message_alert_area">
                            <img src="/assets/images/alert_image.svg" alt="Subscription Alert!" />

                            <p className="review_paragraph text-center">
                                This service is currently not available on the web version. Kindly use the <b>Mobile app</b> to purchase premium or paid packages.
                            </p>

                            <div className="mobile_apps_link_area">
                                <Link target="_blank" to={appStoreLink} className="mb_app_link p-ripple">
                                    <img src="/assets/images/website/home-page/app_store.svg" alt="App Store" loading="lazy" />
                                    <Ripple />
                                </Link>

                                <Link target="_blank" to={playStoreLink} className="mb_app_link p-ripple">
                                    <img src="/assets/images/website/home-page/play_store.svg" alt="Play Store" loading="lazy" />
                                    <Ripple />
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
        </React.Fragment>
    )
}

export default Plans;